// extracted by mini-css-extract-plugin
export default {"root":"v7K1O","bigger-font":"_2rupm","biggerFont":"_2rupm","before-discount":"_2qpGp","beforeDiscount":"_2qpGp"};